import { cn } from "../../lib/cn";

interface Props {
  labels: string[];
  className?: string;
}

export default function TimelineAxis({ labels, className }: Props) {
  return (
    <div
      className={cn("flex w-full justify-between text-[11px] text-on-surface-variant", className)}
    >
      {labels.map((label) => (
        <span key={label}>{label}</span>
      ))}
    </div>
  );
}
